import React from "react";
import { motion } from "framer-motion";
import { Zap, FileDown, Monitor, ShieldCheck } from "lucide-react";

const ITEMS = [
  { icon: Zap, title: "Acceso inmediato", desc: "Recibe el ebook por email al instante después de tu compra." },
  { icon: FileDown, title: "Formato digital", desc: "PDF descargable, listo para usar y compartir en familia." },
  { icon: Monitor, title: "Móvil · Tablet · PC", desc: "Disponible en celular, tablet y computadora. Cocina con él al lado." },
  { icon: ShieldCheck, title: "Pago 100% seguro", desc: "Checkout protegido por Hotmart. Tus datos están seguros." },
];

export default function Guarantees() {
  return (
    <section
      data-testid="guarantees-section"
      className="bg-[#F4EBDE] py-14 md:py-20 border-y border-[#E8DDC9]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              data-testid={`guarantee-${i}`}
              className="flex flex-col items-start gap-3"
            >
              <div className="w-11 h-11 rounded-2xl bg-[#849983]/12 flex items-center justify-center">
                <it.icon className="h-5 w-5 text-[#849983]" strokeWidth={1.6} />
              </div>
              <div>
                <h3 className="font-serif-display text-lg md:text-xl text-[#2A302A] leading-tight">
                  {it.title}
                </h3>
                <p className="text-xs md:text-sm text-[#576057] mt-1 leading-relaxed">
                  {it.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
